import React from "react";
import { Translation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";
import { _cs } from "@togglecorp/fujs";

import DangerButton from "#rsca/Button/DangerButton";
import Modal from "#rscv/Modal";
import ModalBody from "#rscv/Modal/Body";
import ModalHeader from "#rscv/Modal/Header";
import MultiViewContainer, { ViewConfig } from "#rscv/MultiViewContainer";
import ScrollTabs from "#rscv/ScrollTabs";
import { languageSelector } from "#selectors";
import Manual from "./Manual";
import About from "./About";

import { AppState } from "#types";
import styles from "./styles.module.scss";

interface OwnProps {
  className?: string;
  handledisableOutsideDivClick: (disable: boolean) => void;
}

const mapStateToProps = (state: AppState) => ({
  language: languageSelector(state),
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

type Props = OwnProps & ReduxProps;

type ViewKey = "about" | "manual";

class AboutUs extends React.PureComponent<Props, { currentView: ViewKey }> {
  private tabs: Record<ViewKey, string>;
  private views: Record<ViewKey, ViewConfig>;

  constructor(props: Props) {
    super(props);

    const { language } = props.language;

    this.state = { currentView: "about" };

    this.tabs = {
      about: language === "en" ? "Description" : "विवरण",
      manual: language === "en" ? "Publications" : "प्रकाशनहरू",
    };

    const rendererParams = () => ({ className: styles.view });

    this.views = {
      about: { component: About, rendererParams },
      manual: { component: Manual as React.ComponentType, rendererParams },
    };
  }

  private handleTabClick = (key: string) => {
    this.setState({ currentView: key as ViewKey });
  };

  render() {
    const { className, handledisableOutsideDivClick } = this.props;
    const { currentView } = this.state;

    return (
      <Modal className={_cs(styles.loginModal, className)}>
        <Translation>
          {(t) => (
            <ModalHeader
              className={styles.header}
              title={t("BIPAD Portal")}
              rightComponent={
                <DangerButton
                  transparent
                  iconName="close"
                  onClick={() => handledisableOutsideDivClick(false)}
                  title="Close Modal"
                />
              }
            />
          )}
        </Translation>

        <ModalBody className={styles.content}>
          <ScrollTabs
            className={styles.tabs}
            tabs={this.tabs}
            active={currentView}
            onClick={this.handleTabClick}
          />

          <MultiViewContainer views={this.views} active={currentView} />
        </ModalBody>
      </Modal>
    );
  }
}

export default connector(AboutUs);
